import React, { useState } from 'react';
import '../css/CentroInnovacion.css';

import proyectos from '../data/centroInnovacion';


const CentroInnovacion = () => {


    // ============================================
    // VISOR
    // ============================================

    const [selectedProject, setSelectedProject] = useState(null);


    // ============================================
    // ABRIR VISOR
    // ============================================

    const openViewer = (proyecto) => {

        setSelectedProject(proyecto);

    };


    // ============================================
    // CERRAR VISOR
    // ============================================

    const closeViewer = () => {

        setSelectedProject(null);

    };


    // ============================================
    // OBTENER ID DE YOUTUBE
    // ============================================

    const getYouTubeId = (url) => {

        if (!url) {

            return null;

        }


        const patterns = [

            /youtu\.be\/([^?&]+)/,

            /youtube\.com\/watch\?v=([^?&]+)/,

            /youtube\.com\/embed\/([^?&]+)/,

            /youtube\.com\/shorts\/([^?&]+)/,

        ];


        for (const pattern of patterns) {

            const match = url.match(pattern);

            if (match) {

                return match[1];

            }

        }


        return null;

    };


    // ============================================
    // MINIATURA YOUTUBE
    // ============================================

    const getYouTubeThumbnail = (url) => {

        const videoId = getYouTubeId(url);


        if (!videoId) {

            return null;

        }


        return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    };


    // ============================================
    // RENDER MULTIMEDIA DE LAS TARJETAS
    // ============================================

    const renderMedia = (proyecto) => {


        // ========================================
        // YOUTUBE
        // ========================================

        if (proyecto.type === 'youtube') {

            const thumbnail =
                getYouTubeThumbnail(proyecto.link);


            return (

                <div
                    className="esc-ci-social-preview"
                    onClick={() => openViewer(proyecto)}
                >

                    {thumbnail ? (

                        <img
                            src={thumbnail}
                            alt={proyecto.titulo}
                            className="esc-ci-media"
                        />

                    ) : (

                        <div className="esc-ci-placeholder">

                            ▶️

                            <span>
                                Video de YouTube
                            </span>

                        </div>

                    )}


                    <div className="esc-ci-youtube-play">

                        ▶

                    </div>

                </div>

            );

        }


        // ========================================
        // VIDEO LOCAL
        // ========================================

        if (proyecto.type === 'video') {

            return (

                <div
                    className="esc-ci-media-container"
                    onClick={() => openViewer(proyecto)}
                >

                    <video
                        className="esc-ci-media"
                        src={proyecto.archivo}
                        muted
                        loop
                        playsInline
                    />

                    <div className="esc-ci-media-overlay">

                        ▶ Ver video

                    </div>

                </div>

            );

        }


        // ========================================
        // PDF
        // ========================================

        if (proyecto.type === 'pdf') {

            return (

                <div
                    className="esc-ci-media-container"
                    onClick={() => openViewer(proyecto)}
                >

                    <iframe
                        title={proyecto.titulo}
                        src={proyecto.archivo}
                        className="esc-ci-media"
                    />

                    <div className="esc-ci-media-overlay">

                        📄 Ver documento

                    </div>

                </div>

            );

        }


        // ========================================
        // IMAGEN
        // ========================================

        return (

            <div
                className="esc-ci-media-container"
                onClick={() => openViewer(proyecto)}
            >

                <img
                    src={proyecto.archivo}
                    alt={proyecto.titulo}
                    className="esc-ci-media"
                />

                <div className="esc-ci-media-overlay">

                    🔍 Ampliar

                </div>

            </div>

        );

    };


    // ============================================
    // VISOR AMPLIADO
    // ============================================

    const renderViewer = () => {


        if (!selectedProject) {

            return null;

        }


        const proyecto = selectedProject;


        // ========================================
        // YOUTUBE
        // ========================================

        if (proyecto.type === 'youtube') {

            const videoId =
                getYouTubeId(proyecto.link);


            return (

                <div
                    className="esc-ci-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-ci-viewer-content esc-ci-youtube-content"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-ci-viewer-close"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        {videoId ? (

                            <iframe
                                src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                                title={proyecto.titulo}
                                className="esc-ci-youtube-player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowFullScreen
                            />

                        ) : (

                            <div className="esc-ci-error">

                                No se pudo cargar el video de YouTube.

                            </div>

                        )}

                    </div>

                </div>

            );

        }


        // ========================================
        // PDF
        // ========================================

        if (proyecto.type === 'pdf') {

            return (

                <div
                    className="esc-ci-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-ci-viewer-content"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-ci-viewer-close"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <iframe
                            src={proyecto.archivo}
                            title={proyecto.titulo}
                            className="esc-ci-viewer-pdf"
                        />

                    </div>

                </div>

            );

        }


        // ========================================
        // VIDEO LOCAL
        // ========================================

        if (proyecto.type === 'video') {

            return (

                <div
                    className="esc-ci-viewer"
                    onClick={closeViewer}
                >

                    <div
                        className="esc-ci-viewer-content"
                        onClick={(e) => e.stopPropagation()}
                    >


                        <button
                            className="esc-ci-viewer-close"
                            onClick={closeViewer}
                            aria-label="Cerrar"
                        >

                            ✕

                        </button>


                        <video
                            src={proyecto.archivo}
                            controls
                            autoPlay
                            playsInline
                            className="esc-ci-viewer-video"
                        />

                    </div>

                </div>

            );

        }


        // ========================================
        // IMAGEN
        // ========================================

        return (

            <div
                className="esc-ci-viewer"
                onClick={closeViewer}
            >

                <div
                    className="esc-ci-viewer-content"
                    onClick={(e) => e.stopPropagation()}
                >


                    <button
                        className="esc-ci-viewer-close"
                        onClick={closeViewer}
                        aria-label="Cerrar"
                    >

                        ✕

                    </button>


                    <img
                        src={proyecto.archivo}
                        alt={proyecto.titulo}
                        className="esc-ci-viewer-image"
                    />

                </div>

            </div>

        );

    };


    // ============================================
    // RETURN
    // ============================================

    return (

        <section
            id="centro-innovacion-component"
            className="esc-ci-section"
        >


            {/* ==================================
                ENCABEZADO
            ================================== */}

            <div className="esc-ci-header">


                <h2 className="esc-ci-title">

                    Centro de Innovación

                </h2>


                <div className="esc-ci-divider">

                    <span className="esc-ci-red"></span>

                    <span className="esc-ci-blue"></span>

                </div>


                <p className="esc-ci-description">

                    En este espacio compartimos proyectos,
                    experiencias y actividades desarrolladas por
                    nuestros estudiantes en programación,
                    pensamiento computacional, creatividad digital
                    e innovación tecnológica.

                </p>

            </div>


            {/* ==================================
                GRID
            ================================== */}

            <div className="esc-ci-grid">


                {proyectos.map((proyecto) => (

                    <div
                        key={proyecto.id}
                        className="esc-ci-card"
                    >


                        {renderMedia(proyecto)}


                        <div className="esc-ci-content">


                            <span className="esc-ci-category">

                                {proyecto.categoria}

                            </span>


                            <h3>

                                {proyecto.titulo}

                            </h3>


                            <p>

                                {proyecto.descripcion}

                            </p>


                            {proyecto.link && (

                                <a
                                    href={proyecto.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="esc-ci-button"
                                >

                                    Ver Proyecto

                                </a>

                            )}


                        </div>


                    </div>

                ))}


            </div>


            {/* ==================================
                VISOR
            ================================== */}

            {renderViewer()}


        </section>

    );

};


export default CentroInnovacion;
